export default __webpack_public_path__ + "static/media/EM1930.34I-42980_-25685_0.f1566561.jpg";